
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class SplittingItemsGrid extends Serenity.EntityGrid<SplittingItemsRow, any> {
        protected getColumnsKey() { return 'Production.SplittingItems'; }
        protected getDialogType() { return SplittingItemsDialog; }
        protected getIdProperty() { return SplittingItemsRow.idProperty; }
        protected getInsertPermission() { return SplittingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SplittingItemsRow.localTextPrefix; }
        protected getService() { return SplittingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}